const RoleConstants = {
    CARRIER_ADMIN: 'CARRIER_ADMIN',
    FLEET_MANAGER: 'FLEET_MANAGER',
    HOST_ADMIN: 'HOST_ADMIN',
    PROPERTY_MANAGER: 'PROPERTY_MANAGER',
    PARKPRO_ADMIN: 'PARKPRO_ADMIN',
    PARKPRO_SUPER_ADMIN: 'PARKPRO_SUPER_ADMIN',
    DRIVER: 'DRIVER',
};

const roleNameMap = {
    CARRIER_ADMIN: {
        shortName: "Carrier Admin",
        longName: "Carrier Administrator",
    },
    FLEET_MANAGER: {
        shortName: "Fleet Manager",
        longName: "Fleet Manager",
    },
    HOST_ADMIN: {
        shortName: "Host Admin",
        longName: "Host Administrator",
    },
    PROPERTY_MANAGER: {
        shortName: "Property Manager",
        longName: "Property Manager",
    },
    PARKPRO_ADMIN: {
        shortName: "ParkPro Admin",
        longName: "ParkPro Administrator",
    },
    PARKPRO_SUPER_ADMIN: {
        shortName: "ParkPro Admin",
        longName: "ParkPro Super Administrator",
    },
    DRIVER: {
        shortName: "Driver",
        longName: "Pro Driver",
    },
};

export {
    RoleConstants,
    roleNameMap,
}